<template>
  <div class="h-search-body">
    <div class="h-search-ordinary">
      <div class="h-search-back-page" v-if="showBack" @click="backPage">
        <i class="el-icon-arrow-left" style="font-size: 19px"></i>
        <div>返回</div>
      </div>
      <!-- 关键搜索 -->
      <el-input
        v-if="searchParam.keywordModul && searchParam.keywordModul.type == 'input'"
        :disabled="searchParam.keywordModul.disabled ? searchParam.keywordModul.disabled : false"
        :placeholder="searchParam.keywordModul.placeholder"
        v-model="searchInfo[searchParam.keywordModul.key]"
        :style="searchParam.keywordModul.width ? 'width:' + searchParam.keywordModul.width + 'px;' : 'width:500px;'"
      >
        <img slot="prefix" src="../../assets/img/imgNew/icon_ss.png" style="width: 30px; height: 30px" />
      </el-input>
      <el-cascader
        v-if="searchParam.keywordModul && searchParam.keywordModul.type == 'cascader'"
        clearable
        :disabled="searchParam.keywordModul.disabled ? searchParam.keywordModul.disabled : false"
        :props="{ checkStrictly: true }"
        :style="searchParam.keywordModul.width ? 'width:' + searchParam.keywordModul.width + 'px;' : 'width:500px;'"
        v-model="searchInfo[searchParam.keywordModul.key]"
        :placeholder="searchParam.keywordModul.placeholder ? searchParam.keywordModul.placeholder : '请选择'"
        :options="searchParam.keywordModul.options"
      ></el-cascader>
      <!-- 非关键搜索 -->
      <div class="h-search-nokeyword" v-if="searchParam.ordinaryModul && searchParam.ordinaryModul.length > 0">
        <template v-for="(item, i) in searchParam.ordinaryModul">
          <el-input
            v-if="item.type == 'input'"
            v-model="searchInfo[item.key]"
            :disabled="item.disabled ? item.disabled : false"
            :placeholder="item.placeholder ? item.placeholder : '请选择'"
            :style="{ width: item.width ? item.width + 'px' : '260px', 'margin-right': i == searchParam.ordinaryModul.length - 1 ? '0' : '23px' }"
            :key="i"
          ></el-input>
          <el-select
            v-if="item.type == 'select'"
            v-model="searchInfo[item.key]"
            :disabled="item.disabled ? item.disabled : false"
            :placeholder="item.placeholder ? item.placeholder : '请选择'"
            :style="{ width: item.width ? item.width + 'px' : '260px', 'margin-right': i == searchParam.ordinaryModul.length - 1 ? '0' : '23px' }"
            :multiple="item.multiple ? true : false"
            clearable
            :key="i"
          >
            <el-option v-for="item in item.options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
          </el-select>
          <!-- 下拉选 级联 -->
          <el-cascader
            v-if="item.type == 'cascader'"
            :disabled="item.disabled ? item.disabled : false"
            :show-all-levels="item.showAll == 'false' ? false : true"
            :props="{ checkStrictly: item.showAll == 'false' ? false : true }"
            clearable
            :style="{ width: item.width ? item.width + 'px' : '260px', 'margin-right': i == searchParam.ordinaryModul.length - 1 ? '0' : '23px' }"
            v-model="searchInfo[item.key]"
            :placeholder="item.placeholder ? item.placeholder : '请选择'"
            :options="item.options"
            :key="i"
          ></el-cascader>
          <!-- 日期 -->
          <el-date-picker
            value-format="yyyy-MM-dd"
            v-if="item.type == 'datePicker'"
            :disabled="item.disabled ? item.disabled : false"
            :style="{ width: item.width ? item.width + 'px' : '260px', 'margin-right': i == searchParam.ordinaryModul.length - 1 ? '0' : '23px' }"
            v-model="searchInfo[item.key]"
            :key="i"
            :start-placeholder="item.startPlaceholder ? item.startPlaceholder : '开始时间'"
            :end-placeholder="item.endPlaceholder ? item.endPlaceholder : '结束时间'"
            :type="item.pickerType == undefined ? 'daterange' : item.pickerType"
            :picker-options="item.pickerOptions ? item.pickerOptions : ''"
            range-separator="至"
          ></el-date-picker>
        </template>
      </div>
      <button class="search-but search-button" @click="search">搜索</button>
      <button class="reset-but reset-button" :style="openSenior ? '' : showSenior ? 'display:none' : ''" @click="clear">重置</button>
      <div class="senior-but" v-if="showSenior" @click="openSenior = !openSenior">
        高级筛选 <i class="el-icon-arrow-down" :style="{ transform: openSenior ? 'rotate(180deg)' : '' }"></i>
      </div>
      <slot></slot>
    </div>
    <!-- 高级搜索 -->
    <div
      class="h-search-senior"
      v-if="openSenior"
      :style="{
        display: openSenior ? '' : 'none',
        width: compatibilitReturnBtn ? 'calc(100% + 95px)' : '100%',
        'margin-left': compatibilitReturnBtn ? '-95px' : '0px',
      }"
    >
      <template v-for="(item, i) in searchParam.seniorModul">
        <el-input
          v-if="item.type == 'input'"
          v-model="searchInfo[item.key]"
          :disabled="item.disabled ? item.disabled : false"
          :placeholder="item.placeholder ? item.placeholder : '请选择'"
          :style="item.width ? 'width:' + item.width + 'px;' : 'width:260px;'"
          class="search-input"
          :key="i"
        ></el-input>
        <el-select
          v-if="item.type == 'select'"
          filterable
          v-model="searchInfo[item.key]"
          :disabled="item.disabled ? item.disabled : false"
          :placeholder="item.placeholder ? item.placeholder : '请选择'"
          :style="item.width ? 'width:' + item.width + 'px;' : 'width:260px;'"
          class="search-select"
          :multiple="item.multiple ? true : false"
          clearable
          :key="i"
        >
          <el-option v-for="(item,index) in item.options" :key="index" :label="item.label" :value="item.value"> </el-option>
        </el-select>
        <!-- 下拉选 级联 -->
        <el-cascader
          class="search-cascader"
          v-if="item.type == 'cascader'"
          clearable
          :disabled="item.disabled ? item.disabled : false"
          :show-all-levels="item.showAll == 'false' ? false : true"
          :props="{ checkStrictly: item.showAll == 'false' ? false : true, multiple: item.multiple ? item.multiple : false}"
          :style="item.width ? 'width:' + item.width + 'px;' : 'width:300px;'"
          v-model="searchInfo[item.key]"
          :placeholder="item.placeholder ? item.placeholder : '请选择'"
          :options="item.options"
          :key="i"
        ></el-cascader>
        <!-- 四级选择器 -->
        <el-cascader
          class="search-cascader"
          v-if="item.type == 'address'"
          :key="i"
          clearable
          :props="propsprops"
          :style="item.width ? 'width:' + item.width + 'px;' : 'width:300px;'"
          :placeholder="item.placeholder ? item.placeholder : '请选择'"
          v-model="searchInfo[item.key]"
          :disabled="item.disabled ? item.disabled : false"
        >
        </el-cascader>
        <!-- 日期 -->
        <el-date-picker
          class="search-date-picker"
          value-format="yyyy-MM-dd"
          v-if="item.type == 'datePicker'"
          :style="item.width ? 'width:' + item.width + 'px' : 'width: 400px;'"
          v-model="searchInfo[item.key]"
          :key="i"
          :start-placeholder="item.startPlaceholder ? item.startPlaceholder : '开始时间'"
          :end-placeholder="item.endPlaceholder ? item.endPlaceholder : '结束时间'"
          :type="item.pickerType == undefined ? 'daterange' : item.pickerType"
          :format="item.format == undefined ? 'yyyy-MM-dd' : item.format"
          :picker-options="item.pickerOptions ? item.pickerOptions : ''"
          range-separator="至"
        ></el-date-picker>
        <!-- 单日期选择 jws--2023-01-04 -->
        <el-date-picker
          class="search-select"
          value-format="yyyy-MM-dd"
          v-if="item.type == 'date'"
          :style="item.width ? 'width:' + item.width + 'px' : 'width: 400px;'"
          v-model="searchInfo[item.key]"
          :key="i"
          :placeholder="item.placeholder ? item.placeholder : '请选择'"
          :type="item.pickerType == undefined ? 'date' : item.pickerType"
          :format="item.format == undefined ? 'yyyy-MM-dd' : item.format"
        ></el-date-picker>
        <!-- 月份  20230420 yuyang -->
        <el-date-picker
          value-format="yyyy-MM"
          v-model="searchInfo[item.key]"
          :disabled="item.disabled ? item.disabled : false"
          :key="i"
          v-if="item.type == 'datePickerMonth'"
          type="month"
          :placeholder="item.placeholder ? item.placeholder : '请选择月份'"
        >
        </el-date-picker>
        <!-- 范围月份  20230420 yuyang -->
        <el-date-picker
          value-format="yyyy-MM"
          v-model="searchInfo[item.key]"
          :disabled="item.disabled ? item.disabled : false"
          :key="i"
          type="monthrange"
          v-if="item.type == 'monthrange'"
          range-separator="至"
          start-placeholder="开始月份"
          end-placeholder="结束月份"
        >
        </el-date-picker>
      </template>
    </div>
  </div>
</template>
<script>
/*
searchParam:{
  //关键字模式
  keywordModul: {
            key: 'keyword', //关键字，用于保存输入内容
            width: '500', //宽度默认是300 可调整
            placeholder: '搜索关键字、审批标题、编号',
            type:'input',//搜索模式input、cascader
            pickerType:'',//时间框类型(datePicker专属)
            format:'',//时间格式 模式yyyy-MM-DD(datePicker专属)
            showAll:'true',//是否显示完整的路径（cascader专属）
          },
  //非关键模式
  ordinaryModul:[
    {
      type: 'input', //类型：input、select、cascader、datePicker
      key: 'studentName', //关键字，用于保存输入内容
      width: '300', //宽度默认是300 可调整
      placeholder: '请输入学生姓名', 
      options:[], //子选项，用于选择框、日期等(select、cascader使用)
      pickerType:'',//时间框类型(datePicker专属)
      format:'',//时间格式 模式yyyy-MM-DD(datePicker专属)
      showAll:'true',//是否显示完整的路径（cascader专属）
    }
  ],
  //高级筛选
  seniorModul:[
    {
      type: 'input', //类型：input、select、cascader、datePicker、date
      key: 'studentName', //关键字，用于保存输入内容
      width: '300', //宽度默认是300 可调整
      placeholder: '请输入学生姓名', 
      options:[], //子选项(select、cascader使用)
      pickerType:'',//时间框类型(datePicker专属)
      format:'',//时间格式 模式yyyy-MM-DD(datePicker专属)
      showAll:'true',//是否显示完整的路径（cascader专属）值是字符串
    }
  ]
}
showSenior:是否显示高级筛选，默认true
watchKey:需要监听的key
dynamicKey：根据监听的key值动态变化的搜索条件的key值
watchFun:监听值变化的函数
search：查询
clear：重置
showBack:是否显示返回
backPage:返回函数
*/
export default {
  props: {
    searchParam: {
      type: Object,
      default: () => {
        return {
          showSenior: true,
        }
      },
    },
    showSenior: {
      type: Boolean,
      default: true,
    },
    watchKey: {
      type: String,
    },
    dynamicKey: {
      type: Array,
    },
    compatibilitReturnBtn: {
      type: Boolean,
      default: false,
    },
    showBack: {
      type: Boolean,
      default: false,
    },
    level: {
      type: Number,
      default: 3,
    },
  },
  data() {
    return {
      openSenior: false,
      searchInfo: {},
      propsprops: {
        checkStrictly: true,
        lazy: true,
        lazyLoad: this.lazyLoad,
      },
      parentCode: -1,
    }
  },
  watch: {
    searchParam: {
      handler(valueNew, valueOld) {
        console.log('---------------searchParam:', valueOld, valueNew)
        if(valueNew.seniorModul){
          valueNew.seniorModul.forEach(ele =>{
            if(ele.defaultValue){
              this.$set(this.searchInfo, ele.key, ele.defaultValue);
            }
          })
        }
      },
      deep: true,
      immediate: true,
    },
    watchKeyValue: {
      handler(valueNew, valueOld) {
        // console.log('---------------searchInfo:', valueNew, valueOld)
        if (valueNew != valueOld) {
          this.$emit('watchFun', valueNew)
        }
      },
      deep: true,
      immediate: true,
    },
    //若是动态搜索条件的key值有变化需要清除searchInfo里之前的key
    dynamicKey: {
      handler(valueNew, valueOld) {
        // console.log('---------------dynamicKey:', valueNew, valueOld)
        if (valueOld && valueOld.length > 0) {
          valueOld.forEach((key) => {
            delete this.searchInfo[key]
          })
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    watchKeyValue() {
      return this.searchInfo[this.watchKey]
    },
  },
  mounted() {},
  beforeDestroy() {
    console.log('--------beforeDestroy')
  },
  methods: {
    chandleChange(e) {
      console.log('eee', e)
    },
    lazyLoad(node, resolve) {
      setTimeout(() => {
        this.getProvence(node, resolve)
      }, 1000)
    },
    getProvence(node, resolve) {
      // console.log('node',node)
      if (node.data) {
        this.parentCode = node.data.parentCode
      }
      // console.log('resolve',resolve)
      let data = {}
      data.parentCode = this.parentCode
      this.$API['getArea'](data)
        .then((res) => {
          console.log('res', res)
          if (Array.isArray(res)) {
            const nodes = res.map((item) => ({
              value: item.name, //
              // value: item.name,
              label: item.name,
              parentCode: item.code,
              leaf: node.level >= this.level, // 4层级
            }))
            resolve(nodes)
          } else {
            this.$message.error(res.data.value || res.data.error)
          }
        })
        .catch((error) => this.$message.error(error))
    },
    search() {
      console.log('searchInfo search:', this.searchInfo)
      //
      let data = {}
      for (const key in this.searchInfo) {
        console.log('key', key)
        console.log('this.searchInfo[key].length > 0')
        if (this.searchInfo[key] && '' !== this.searchInfo[key] && undefined !== this.searchInfo[key]) {
          if (this.searchInfo[key] instanceof Array && this.searchInfo[key].length > 0) {
            data[key] = this.searchInfo[key]
          } else {
            data[key] = this.searchInfo[key]
          }
        }
      }
      this.$emit('search', data)
    },
    clear() {
      this.searchInfo = {}

      this.$emit('clear')
    },
    handleClear() {
      //用于手动清理查询信息
      this.searchInfo = {}
      this.openSenior = false
    },
    backPage() {
      this.$emit('backPage')
    },
  },
}
</script>
<style lang='less'>
.displayFlex {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.h-search-body {
  width: 100%;
  .displayFlex;
  align-items: flex-start;
  flex-direction: column;
  .h-search-ordinary {
    .displayFlex;
    justify-content: flex-start;
    // width: 636px;
    position: relative;
    width: 100%;
    .h-search-back-page {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 18px;
      width: 80px;
      color: #17A48B;
      margin-right: 30px;
    }
    .h-search-nokeyword {
      .displayFlex;
      justify-content: flex-start;
      position: relative;
      flex-wrap: wrap;
      align-items: center;
      // width: 100%;
      // margin-top: 20px;
    }
    .senior-but {
      cursor: pointer;
      .displayFlex;
      height: 100%;
      text-align: center;
      font-size: 16px;
      font-weight: 400;
      color: #17A48B;
      margin-left: 28px;
    }
  }

  .search-but {
    margin-left: 20px;
  }

  .reset-but {
    margin-left: 20px;
  }

  .h-search-senior {
    .displayFlex;
    justify-content: flex-start;
    position: relative;
    flex-wrap: wrap;
    width: 100%;
    margin-top: 10px;
  }
  .search-input {
    width: 260px;
    height: 42px;
    margin-right: 23px;
    margin-bottom: 10px;
  }

  .search-select {
    width: 260px;
    // height: 42px;
    margin-right: 23px;
    margin-bottom: 10px;
  }

  .search-cascader {
    margin-right: 23px;
    margin-bottom: 10px;
  }

  .search-date-picker {
    margin-right: 23px;
    margin-bottom: 10px;
  }
}

.el-input--prefix .el-input__inner {
  padding-left: 54px;
  font-size: 16px;
}

.el-input__prefix {
  left: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/parts/h-search-new.vue